import { Button, Spacer } from '@loomhq/lens';
import React from 'react';

import * as oAuthKeys from 'constants/oAuthKeys';
import * as analytics from 'utilities/analytics';
import * as auth from 'utilities/auth';

import googleIconSrc from 'img/icons/google.svg';
import slackIconSrc from 'img/icons/slack.svg';

import { OAUTH_BUTTON_CLICKED } from '../../../constants/events';

import './styles.less';

function ConnectButtons(props) {
  const { isSignUp, overlayMode, afterAuthCallback } = props;

  const connect = provider => {
    auth.openOAuthPopup(provider, afterAuthCallback);

    analytics.track(OAUTH_BUTTON_CLICKED, {
      provider,
      isSignUp,
    });
  };

  return (
    <div className="loom-signup-component-connect-buttons">
      <Button
        logoSrc={googleIconSrc}
        hasFullWidth={true}
        size={overlayMode ? 'medium' : 'large'}
        onClick={() => connect(oAuthKeys.GOOGLE)}
      >
        {isSignUp ? 'Sign up with Google' : 'Sign in with Google'}
      </Button>
      <Spacer top={2} />
      <Button
        logoSrc={slackIconSrc}
        hasFullWidth={true}
        size={overlayMode ? 'medium' : 'large'}
        onClick={() => connect(oAuthKeys.SLACK)}
      >
        {isSignUp ? 'Sign up with Slack' : 'Sign in with Slack'}
      </Button>
    </div>
  );
}

export default ConnectButtons;
